import type { Role } from "@/api/auth";

export const ROLE_RANK: Record<Role, number> = {
  employee: 0,
  manager: 1,
  org_admin: 2,
  platform_admin: 3,
};

export const ROLE_LABELS: Record<Role, { nl: string; en: string }> = {
  employee: { nl: "Medewerker", en: "Employee" },
  manager: { nl: "Manager", en: "Manager" },
  org_admin: { nl: "Org-beheerder", en: "Org admin" },
  platform_admin: { nl: "Platform-beheerder", en: "Platform admin" },
};

export function roleLabel(role: Role, t: (nl: string, en: string) => string): string {
  return t(ROLE_LABELS[role].nl, ROLE_LABELS[role].en);
}

export type TenantRole = "org_admin" | "manager" | "employee";

/** True if an actor may manage a target (strictly lower role). */
export function canManage(actor: Role, target: Role): boolean {
  return ROLE_RANK[target] < ROLE_RANK[actor];
}

/** Roles an actor may assign — strictly below their own. */
export function rolesBelow(actor: Role): TenantRole[] {
  return (["org_admin", "manager", "employee"] as TenantRole[]).filter((r) => ROLE_RANK[r] < ROLE_RANK[actor]);
}
